import { ElementGroup } from "../elements";
import { DesignElementSnapshotBase, pickLatestSnapshots } from "./base";
/**
 * Snapshot of an element group.
 *
 * Please note that existence of snapshot's references (including parent persistent id) is not guaranteed.
 */
export const ElementGroupSnapshot = DesignElementSnapshotBase.extend({
    group: ElementGroup,
});
//
// Util functions
//
export function pickLatestGroupSnapshots(snapshots) {
    return pickLatestSnapshots(snapshots, (s) => s.group.id);
}
